import React from 'react';
import { Badge, Button, Dropdown, Empty, Tag, Typography } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { navigateToLink as goToLink } from '../../utils/approvalCenterNav';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
import { getCategoryMeta, getMsgTypeMeta } from '../../config/inboxCategoryMeta';
import './InboxBell.css';

dayjs.extend(relativeTime);
dayjs.locale('zh-cn');

const { Text } = Typography;

const InboxBell = ({ unreadTotal = 0, recent = [], onMarkRead, onMarkAllRead }) => {
  const navigate = useNavigate();

  const handleOpenMessage = (item) => {
    if (!item.is_read) {
      onMarkRead?.([item.id]);
    }
    if (!item.link_path) {
      navigate('/messages');
      return;
    }
    goToLink(navigate, item.link_path);
  };

  const dropdownContent = (
    <div className="inbox-bell-panel">
      <div className="inbox-bell-panel-header">
        <Text strong>站内信</Text>
        {unreadTotal > 0 && (
          <Button type="link" size="small" onClick={() => onMarkAllRead?.()}>
            全部已读
          </Button>
        )}
      </div>
      <div className="inbox-bell-panel-body">
        {!recent.length ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无消息" />
        ) : (
          recent.map((item) => {
            const cat = getCategoryMeta(item.category);
            const msg = getMsgTypeMeta(item.msg_type);
            return (
              <button
                key={item.id}
                type="button"
                className={`inbox-bell-item${item.is_read ? '' : ' inbox-bell-item--unread'}`}
                onClick={() => handleOpenMessage(item)}
              >
                <div className="inbox-bell-item-top">
                  <Tag color={cat.color} bordered={false}>{cat.label}</Tag>
                  <Tag bordered={false}>{msg.label}</Tag>
                  <span className="inbox-bell-item-time">
                    {dayjs(item.create_time).fromNow()}
                  </span>
                </div>
                <div className="inbox-bell-item-title">{item.title}</div>
                {item.content && (
                  <div className="inbox-bell-item-content">{item.content}</div>
                )}
              </button>
            );
          })
        )}
      </div>
      <div className="inbox-bell-panel-footer">
        <Button type="link" block onClick={() => navigate('/messages')}>
          查看全部消息
        </Button>
      </div>
    </div>
  );

  return (
    <Dropdown
      popupRender={() => dropdownContent}
      trigger={['click']}
      placement="bottomRight"
    >
      <button type="button" className="inbox-bell-trigger" aria-label="站内信">
        <Badge count={unreadTotal} size="small" offset={[-2, 2]}>
          <BellOutlined className="inbox-bell-icon" />
        </Badge>
      </button>
    </Dropdown>
  );
};

export default InboxBell;
